import StatisticsModule from '@justeat/f-statistics';

export default ({ store, $justLog, req }, inject) => {
    const { environment } = store.state.configuration;

    const configuration = {
        featureName: 'CoreWeb',
        environment
    };

    const baseProperties = {
        userAgent: process.server ? req.headers['user-agent'] : navigator.userAgent
    };

    const statsClient = new StatisticsModule($justLog, configuration, baseProperties);

    // this.$statistics.publish(message, { measure: 12345 });
    inject('statistics', statsClient);
};
